//
//
//

export default {
name: 'DivSelector',
  data() {
    return {
      currentValue: this.value,
      imageSrc:null,
      listData:[],
      allData:[]
    };
  },
  props:['dictCode','value','selectMemo','hided'],
  mounted(){
    this.$get('/api/dict-tables/search-with-list', {dictCode: this.dictCode}).then((info) => {
      if(info.dictItems){
        this.allData = info.dictItems;
        this.getListData();
      }
    }).catch(error => {

    });
  },
  methods:{
    setCurrentValue(value) {
      if (value === this.currentValue) return;
      this.currentValue = value;
    },
    onChange(e) {
      this.$emit('input', e);
      this.$emit('selectChange',e);
      for(let i = 0;i < this.listData.length;i++){
        if(e === this.listData[i].code){
          this.$emit('dictChange',this.listData[i]);
          break;
        }
      }
    },
    getListData(){
      this.listData = this.allData.filter((item) => {
        return item['enabled'] && !(this.hided && this.hided.includes(item.code)) && ((this.selectMemo && item['describe'].includes(this.selectMemo)) || !this.selectMemo);
      })
    }
  },
  watch: {
    value(val) {
      this.setCurrentValue(val);
    },
    selectMemo(){
      this.getListData();
    }
  },
}




// WEBPACK FOOTER //
// ./src/components/DivSelector.vue